var map = {
	"./Entypo.ttf": 365,
	"./EvilIcons.ttf": 366,
	"./FontAwesome.ttf": 367,
	"./Foundation.ttf": 368,
	"./Ionicons.ttf": 369,
	"./MaterialCommunityIcons.ttf": 370,
	"./MaterialIcons.ttf": 371,
	"./Octicons.ttf": 372,
	"./SimpleLineIcons.ttf": 373,
	"./Zocial.ttf": 374
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;



//////////////////
// WEBPACK FOOTER
// ./~/react-native-vector-icons/Fonts ^\.\/.*\.ttf$
// module id = 364
// module chunks = 0